var _interface = require('util/interface').interface;
var DataType = require('../datatype');

/**
 * Binary data type.
 * <P>
 * Accessed via:
 * <code>diffusion.datatypes.binary();</code>
 * <P>
 * The implementation provides support for binary deltas.
 * <P>
 * {@link diffusion.datatypes.Binary} values can be used to store and transmit arbitrary
 * information. The responsibility for formatting and interpreting the
 * information belongs solely to the application. Before using Binary for a
 * topic, consider other data types such as {@link diffusion.datatypes.JSON JSON} or
 * single value topic types; these may provide a simpler interface for
 * your application.
 * @class diffusion.datatypes.BinaryDataType
 * @augments diffusion.datatypes.DataType
 * @since 5.7
 */
module.exports = _interface('BinaryDataType', DataType, [
    /**
     * Returns a new {@link diffusion.datatypes.Binary} instance from a buffer.
     *
     * @param {Buffer} buffer - The binary data
     * @return {diffusion.datatypes.Binary} a Binary data-type instance
     *
     * @function diffusion.datatypes.BinaryDataType#from
     */
    'from'
]);




//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/data/binary/binary-datatype.js
// module id = 982
// module chunks = 1